import { queryOptions } from '@tanstack/react-query'
import { apiGet } from './client'

/**
 * Contractul lui GET /api/v2/settings/easeedesk/menu
 * (v4/api, App\Settings\Easeedesk\EaseedeskMenu).
 *
 * Tot ce vine de aici e DEJA filtrat pe drepturi, pe server - ca la
 * `settingsDrawer` si `settingsRail`. Interfata deseneaza ce a primit si nu
 * intreaba nimic despre roluri: cele saptezeci de porti ale meniului vechi se
 * judeca intr-un singur loc, si acela nu e browserul.
 *
 * Nu vin nici intrarile ale caror ecrane nu s-au rescris inca. Portalul vechi a
 * fost scos de pe server, deci un rand catre un ecran care nu exista duce la o
 * pagina goala - iar o pagina goala e mai rea decat un rand lipsa.
 */

/** Un ecran: randul care se apasa. */
export interface EaseedeskMenuEntry {
  kind: 'entry'
  label: string
  /** Adresa din portal, fara `/app` (`settings/easeedesk/ticket_types_settings`). */
  url: string
  /** Clasa iconitei, sau sirul gol - randurile dinauntrul unui submeniu n-au. */
  icon: string
  /** Insigna rosie „beta" de langa nume (un singur rand o poarta). */
  beta: boolean
  active: boolean
}

/** Un cap de submeniu: nu duce nicaieri, deschide o lista. */
export interface EaseedeskMenuGroup {
  kind: 'group'
  label: string
  icon: string
  /** Deschis din pornire fiindca randul aprins e sub el. */
  open: boolean
  items: EaseedeskMenuEntry[]
}

export type EaseedeskMenuItem = EaseedeskMenuEntry | EaseedeskMenuGroup

/** Un capitol: „Tickets", „Workflows", „Ticket notifications", ... */
export interface EaseedeskMenuSection {
  label: string
  items: EaseedeskMenuItem[]
}

export interface EaseedeskMenuData {
  /**
   * Meniul se deseneaza pe adresa asta?
   *
   * Nu e acelasi lucru cu „adresa incepe cu settings/easeedesk". Doua intrari
   * ies din arborele lor - „SKUs Report Settings" duce la
   * `settings/diagnostic_reports/skus_report` - si pe ecranele alea meniul
   * trebuie sa ramana, altfel cine le apasa nu mai are drum inapoi. Raspunsul
   * il da serverul, care are lista; aici nu se ghiceste dintr-un prefix.
   */
  owns: boolean
  /** Adresa randului aprins, sau sirul gol cand niciunul nu e. */
  active: string
  sections: EaseedeskMenuSection[]
}

/**
 * Meniul depinde de adresa DOAR prin randul aprins, si aprinderea se poate
 * socoti si aici. Cheia ramane totusi pe adresa: raspunsul poarta `active`, iar
 * doua chei diferite cu acelasi continut costa mai putin decat doua locuri care
 * ghicesc pagina curenta si ajung sa raspunda diferit.
 */
export function easeedeskSettingsMenuQuery(path: string) {
  return queryOptions({
    queryKey: ['settings-easeedesk-menu', path],
    queryFn: () => apiGet<EaseedeskMenuData>(`/settings/easeedesk/menu?path=${encodeURIComponent(path)}`),
    staleTime: 5 * 60 * 1000,
  })
}
